import { render, staticRenderFns } from "./NavigationDrawerItems.vue?vue&type=template&id=49d3b9af&scoped=true"
import script from "./NavigationDrawerItems.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerItems.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerItems.vue?vue&type=style&index=0&id=49d3b9af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d3b9af",
  null
  
)

export default component.exports